import { gql } from '@apollo/client';

const TRANSFER_PRODUCT = gql`
  mutation TransferProduct($newUsername: String!, $productUserId: ID!) {
    transferProduct(newUsername: $newUsername, productUserId: $productUserId) {
      errors
      success
      productUser {
        uuid
        isActive
        isArchived
        transferStatus
        transferFrom {
          productSbuUser {
            username
          }
        }
        product {
          id
          altTitle
          altDescription
        }
        transferredAt
        updatedAt
      }
    }
  }
`;

const CONFIRM_PRODUCT_TRANSFER = gql`
  mutation ConfirmProductTransfer($action: String!, $productTransferId: ID!) {
    confirmProductTransfer(
      action: $action
      productTransferId: $productTransferId
    ) {
      success
      errors
      productUser {
        uuid
        isActive
        isArchived
        createdAt
        transferStatus
        updatedAt
        transferredAt
        transferFrom {
          uuid
          productSbuUser {
            username
            user {
              firstName
              lastName
            }
          }
        }
      }
    }
  }
`;
const PIN_PRODUCT_MUTATION = gql`
  mutation SetProductUserPinned($productUserId: ID!, $isPinned: Boolean!) {
    setProductUserPinned(productUserId: $productUserId, isPinned: $isPinned) {
      success
      errors
      productUser {
        uuid
        isPinned
      }
    }
  }
`;

const UPDATE_PRODUCT_MANAGER_PURCHASE_NOTIFICATION = gql`
  mutation UpdateProductManagerPurchaseNotification(
    $pmUuid: String = ""
    $purchaseNotification: Boolean = false
  ) {
    updateProductManagerPurchaseNotification(
      pmUuid: $pmUuid
      purchaseNotification: $purchaseNotification
    ) {
      success
      errors
      productManager {
        uuid
        purchaseNotification
        updatedAt
        createdAt
      }
    }
  }
`;
export {
  TRANSFER_PRODUCT,
  CONFIRM_PRODUCT_TRANSFER,
  PIN_PRODUCT_MUTATION,
  UPDATE_PRODUCT_MANAGER_PURCHASE_NOTIFICATION,
};
